(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Warning", [], factory);
	else if(typeof exports === 'object')
		exports["Warning"] = factory();
	else
		root["Warning"] = factory();
})(this, function() {
return 